import React, { useEffect, useState } from "react";
import { RefreshCcw } from "lucide-react";
import { REPORT_CACHE_TTL_MS } from "../../utils/reportCache";

// One shared "Refresh Report (X min ago)" control for every report page.
// Ticks its own label forward every 15s (no parent re-render needed), and
// calls onAutoRefresh once the cache's TTL is reached — same 30-minute
// window reportCache.js itself enforces, so this visual timer and the
// actual cache expiry can never drift apart.
const RefreshReportBar = ({ savedAt, refreshing, onRefresh, onAutoRefresh }) => {
    const [, forceTick] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => forceTick((t) => t + 1), 15000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!savedAt) return;
        const remaining = REPORT_CACHE_TTL_MS - (Date.now() - savedAt);
        if (remaining <= 0) {
            onAutoRefresh();
            return;
        }
        const timeout = setTimeout(onAutoRefresh, remaining);
        return () => clearTimeout(timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [savedAt]);

    const label = (() => {
        if (!savedAt) return "Refresh Report";
        const minsAgo = Math.floor((Date.now() - savedAt) / 60000);
        if (minsAgo < 1) return "Refresh Report (just now)";
        return `Refresh Report (${minsAgo}m ago)`;
    })();

    return (
        <button onClick={onRefresh} disabled={refreshing}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-50 border border-gray-200 rounded-lg text-xs font-bold text-gray-600 hover:bg-gray-100 transition disabled:opacity-50">
            <RefreshCcw size={12} className={refreshing ? "animate-spin" : ""} />
            {refreshing ? "Refreshing..." : label}
        </button>
    );
};

export default RefreshReportBar;